
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plasmic-host",
      function () {
        return require("private-next-pages/plasmic-host.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plasmic-host"])
      });
    }
  